import { graphql } from 'gql';

export const uerWorkOrderUsersSelectionListCodeFilter = graphql(`
    query uerWorkOrderUsersSelectionListCodeFilter(
        $skip: Int
        $take: Int
        $workOrderId: Long!
        $constructionTypeId: Int!
        $workOrderObjectIds: [Long!]!
        $chapter: ChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerWorkOrderUsersSelectionListCodeFilter(
            skip: $skip
            take: $take
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            workOrderObjectIds: $workOrderObjectIds
            chapter: $chapter
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerWorkOrderUsersSelectionListNameFilter = graphql(`
    query uerWorkOrderUsersSelectionListNameFilter(
        $skip: Int
        $take: Int
        $workOrderId: Long!
        $constructionTypeId: Int!
        $workOrderObjectIds: [Long!]!
        $chapter: ChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerWorkOrderUsersSelectionListNameFilter(
            skip: $skip
            take: $take
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            workOrderObjectIds: $workOrderObjectIds
            chapter: $chapter
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerWorkOrderUsersSelectionListGroupFilter = graphql(`
    query uerWorkOrderUsersSelectionListGroupFilter(
        $skip: Int
        $take: Int
        $workOrderId: Long!
        $constructionTypeId: Int!
        $workOrderObjectIds: [Long!]!
        $chapter: ChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerWorkOrderUsersSelectionListGroupFilter(
            skip: $skip
            take: $take
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            workOrderObjectIds: $workOrderObjectIds
            chapter: $chapter
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerWorkOrderUsersSelectionListSectionFilter = graphql(`
    query uerWorkOrderUsersSelectionListSectionFilter(
        $skip: Int
        $take: Int
        $workOrderId: Long!
        $constructionTypeId: Int!
        $workOrderObjectIds: [Long!]!
        $chapter: ChapterEnum!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerWorkOrderUsersSelectionListSectionFilter(
            skip: $skip
            take: $take
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            workOrderObjectIds: $workOrderObjectIds
            chapter: $chapter
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);
